// Module
var code = "<div class=\"dms-board-wrapper dms-outer-element\">\n    <div class=\"dms-grid-wrapper dms-board #:data.GridName#\"></div>\n</div>";
// Exports
export default code;